import { cn } from '@/lib/utils'

export const DEFAULT_AGENT_NAME = 'Agent'

export const getWrapperClassName = (wrapperClassName?: string, className?: string): string =>
  cn('group flex items-start gap-2 py-2', wrapperClassName, className)

export const getCardClassName = (cardClassName?: string, isClickable?: boolean): string =>
  cn(
    'flex min-w-0 flex-1 rounded-lg border bg-card px-3 py-2.5',
    'transition-all duration-150',
    isClickable && 'cursor-pointer hover:border-primary/30 hover:bg-accent/50 hover:shadow-sm',
    cardClassName
  )
